import {
  GET_USER_LIST,
  GET_TEAM_LIST,
  GET_TEAM_SETUP,
  UPDATE_TEAM_MEMBER_ROLE,
  DELETE_TEAM_MEMBER,
  ADD_TEAM_MEMBER,
  GET_TEAM_APPLICATIONS
} from '@stores/mutation-types';
import {
  TeamVolunteering
} from '@services/App/teamVolunteering';
import store from '../../store';

const state = () => ({
  users: [],
  teams: [],
  setup: [],
  applications: [],
  member: {
    updated: null,
    deleted: null,
    added: null
  }
});

const mutations = {
  [GET_USER_LIST]: (state, payload) => {
    state.users = payload ? payload : [];
  },

  [GET_TEAM_LIST]: (state, payload) => {
    state.teams = payload ? payload : [];
  },

  [GET_TEAM_SETUP]: (state, payload) => {
    state.setup = payload ? payload : [];
  },

  [UPDATE_TEAM_MEMBER_ROLE]: (state, isUpdated) => {
    state.member.updated = isUpdated;
  },

  [DELETE_TEAM_MEMBER]: (state, isDeleted) => {
    state.member.deleted = isDeleted;
  },

  [ADD_TEAM_MEMBER]: (state, isAdded) => {
    state.member.added = isAdded;
  },

  [GET_TEAM_APPLICATIONS]: (state, payload) => {
    state.applications = payload ? payload : [];
  },
};

const actions = {
  /**
   * Get list of users
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async listUsers({ commit, state }, params) {
    const response = await TeamVolunteering.listUsers(params);

    if (response.success) {
      commit(GET_USER_LIST, response.data);

      return params.hasOwnProperty('page')
        ? { users: state.users, pagination: response.pagination }
        : { users: state.users };
    }

    return state.users;
  },

  /**
   * Manage team data
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async manageTeam({ commit, state }, params) {
    const response = await TeamVolunteering.manageTeam(params, params.get('team_id'));

    return response.data.team_id ? response.data.team_id : false;
  },

  /**
   * Get list of teams
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async listTeams({ commit, state }, params) {
    try {
      const response = await TeamVolunteering.listTeams(params);

      if (response.success) {
        commit(GET_TEAM_LIST, response);
      }

      return state.teams;
    } catch (error) {
      commit(GET_TEAM_LIST, false);

      return 'error';
    }
  },

  /**
   * Get team setup
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async getSetup({ commit, state }) {
    if (state.setup.length) {
      return state.setup;
    }

    const response = await TeamVolunteering.getSetup();

    if (response.success) {
      commit(GET_TEAM_SETUP, response.data);
    }

    return state.setup;
  },

  /**
   * Update team member role
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async updateMemberRole({ commit, state }, params) {
    const response = await TeamVolunteering.updateMemberRole(params);

    if (response.success) {
      commit(UPDATE_TEAM_MEMBER_ROLE, true);
    } else {
      commit(UPDATE_TEAM_MEMBER_ROLE, false);
    }

    return state.member.updated;
  },

  /**
   * Update team member role
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async deleteMember({ commit, state }, params) {
    const response = await TeamVolunteering.deleteMember(params);

    if (response.success) {
      commit(DELETE_TEAM_MEMBER, true);
    } else {
      commit(DELETE_TEAM_MEMBER, false);
    }

    return state.member.deleted;
  },

  /**
   * Update team member role
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async addMember({ commit, state }, params) {
    const response = await TeamVolunteering.addMember(params);

    if (response.success) {
      commit(ADD_TEAM_MEMBER, true);
    } else {
      commit(ADD_TEAM_MEMBER, false);
    }

    return state.member.added;
  },

  /**
   * List applications of the team
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async listTeamApplications({ commit, state }, params) {
    const response = await TeamVolunteering.listTeamApplications(params);

    if (response.success) {
      commit(GET_TEAM_APPLICATIONS, response);
    }

    return state.applications;
  },

  /**
   * Archive team
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async archiveTeam({ commit, state }, params) {
    const { code } = await TeamVolunteering.archiveTeam(params.teamId);

    return code === 200;
  },

  /**
   * Message team
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async messageTeam({ commit, state }, params) {
    const { code } = await TeamVolunteering.messageTeam(params);

    return code === 200;
  },

  /**
   * Join user to a team
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async joinTeam({ commit, state }, teamId) {
    const { code } = await TeamVolunteering.joinTeam(teamId);

    return code === 200;
  },

  /**
   * Leave the team
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async leaveTeam({ commit, state }, teamId) {
    const { code } = await TeamVolunteering.leaveTeam(teamId);

    return code === 200;
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
